"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.PreVisitCheckIn = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intl = require("@kyruus/intl");
var _button = require("@kyruus/button");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
var _styles = require("./styles");
const PreVisitCheckIn = _ref => {
  let {
    checkInUrl,
    track,
    providerId
  } = _ref;
  const handleClick = () => {
    track('user_action.direct_book.appointment_confirmation_page.check_in', {
      provider_id: providerId
    });
    if (typeof window !== undefined) {
      window.location.href = checkInUrl;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_styles.PreVisitContainer, {
    "data-testid": "ApptSummary__PreVisitCheckIn"
  }, /*#__PURE__*/_react.default.createElement(_styles.PreVisitTitle, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.preVisitTitle)), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.preVisitDescription)), /*#__PURE__*/_react.default.createElement(_button.Button, {
    "data-testid": "ApptSummary__PreVisitCheckIn__Button",
    mode: "primary",
    type: "button",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.preVisitButton)));
};
exports.PreVisitCheckIn = PreVisitCheckIn;
PreVisitCheckIn.propTypes = {
  checkInUrl: _propTypes.default.string,
  track: _propTypes.default.func,
  providerId: _propTypes.default.number
};
PreVisitCheckIn.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PreVisitCheckIn",
  "props": {
    "checkInUrl": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "providerId": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    }
  }
};